<template>
    <div>
        <div class="admin-main-header">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>首页</el-breadcrumb-item>
                <el-breadcrumb-item>仪表盘</el-breadcrumb-item>
                <el-breadcrumb-item>工作台</el-breadcrumb-item>
            </el-breadcrumb>
            <div>
                <el-row>
                    <el-col :span="16">
                        <div class="myself">
                            <img :src="loginUser.userIconUrl" />
                            <h1>{{timeGreeting}}，{{loginUser.userName}}，欢迎您!</h1>
                            <p>{{loginUser.primaryRoleName}} | {{loginUser.realName}} &nbsp;&nbsp;-&nbsp;&nbsp; 机动车综合服务平台</p>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="statistics">
                            <div class="item">
                                <span>访问量</span>
                                <p>{{loginUser.loginTimes}}</p>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div class="admin-main-body">
            <el-row :gutter="20">
                <el-col :span="16">
                    <el-card class="project">
                        <div slot="header" class="el-clearfix">
                            <span>平台主要功能一览</span>
                            <el-button style="float: right; padding: 3px 0" type="text">全部功能</el-button>
                        </div>
                        <div class="project-list el-clearfix">
                            <div class="project-item">
                                <h3>
                                    <i class="fab fa-ubuntu" style="color:#4D8DF1;"></i> <a href="javascript:void(0);">用户权限管理</a>
                                </h3>
                                <p>提供基于标准RBAC权限体系的用户、角色、资源的管理及配置，动态可控的用户权限配置功能。</p>
                            </div>
                            <div class="project-item">
                                <h3>
                                    <i class="fas fa-cogs" style="color:#003979;font-size:20px;"></i> <a href="javascript:void(0);">平台基础数据管理</a>
                                </h3>
                                <p>平台团队长、营销员等角色的人员管理，平台组织机构(公司)管理，以及服务对象及服务项目管理。</p>
                            </div>
                            <div class="project-item">
                                <h3>
                                    <i class="fas fa-chalkboard" style="color:#008D4C;font-size:21px;"></i> <a href="javascript:void(0);">按车主和服务项目分销任务</a>
                                </h3>
                                <p>此类分销任务是按服务对象(车主)、服务项目及金额在线发布任务。其他公司管理员可以接受该任务并分配给指定的团队长，完成任务。</p>
                            </div>
                            <div class="project-item">
                                <h3>
                                    <i class="fab fa-chromecast" style="color:#6F5499;"></i> <a href="javascript:void(0);">按团队长和总金额分销任务</a>
                                </h3>
                                <p>此类分销任务是按团队长、服务总金额批量导入分销任务。导入过程即将指定的总金额按照一定的金额范围随机分配给指定团队长下的营销员(若营销员不足则会借调)。</p>
                            </div>
                            <div class="project-item">
                                <h3>
                                    <i class="fas fa-desktop" style="color:#8A418A;font-size:21px;"></i> <a href="javascript:void(0);">批量导入任务清单</a>
                                </h3>
                                <p>线下产生的具体任务分销清单(即某团队长下的某营销员向某车主提供了某金额的服务)，导入到平台中。导入过程中将指定金额随机分配到服务项目上。</p>
                            </div>
                            <div class="project-item">
                                <h3>
                                    <i class="fas fa-bars" style="color:#DB7C22;"></i> <a href="javascript:void(0);">所有任务清单查询及导出</a>
                                </h3>
                                <p>以上三种方式产生的任务清单明细，平台提供了汇总查询及导出服务，其中导出只能按照任务ID来导出任务清单明细信息。</p>
                            </div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="8">
                    <el-calendar class="calendar" v-model="nowDate"></el-calendar>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Index',
    props: {
        nowDate: {
            type: Date,
            default() {
                return new Date();
            }
        }
    },
    data() {
        return {};
    },
    computed: {
        loginUser() {
            return this.$store.state.loginUserAllData.loginUser;
        },
        timeGreeting() {
            let nowDate = new Date();
            let hour = nowDate.getHours();
            if (hour >= 6 && hour < 8) {
                return '早上好';
            } else if (hour >= 8 && hour < 11) {
                return '上午好';
            } else if (hour >= 11 && hour < 13) {
                return '中午好';
            } else if (hour >= 13 && hour < 18) {
                return '下午好';
            } else {
                return '晚上好';
            }
        }
    }
};
</script>

<style lang="scss">
.myself {
    position: relative;
    padding: 15px 0 15px 80px;
    img {
        position: absolute;
        left: 5px;
        top: 35px;
        border: 0 none;
        width: 60px;
        height: 60px;
        border-radius: 50%;
    }
    h1 {
        padding: 15px 0;
        font-size: 20px;
        font-weight: 500;
        color: $--color-text-primary;
    }
    p {
        font-size: 14px;
        color: $--color-text-secondary;
        padding: 0;
        line-height: 32px;
    }
}
.statistics {
    vertical-align: top;
    .item {
        display: inline-block;
        vertical-align: top;
        width: 33%;
        padding: 30px 0 0 0;
        span {
            color: $--color-text-secondary;
            font-size: 14px;
        }
        p {
            font-size: 24px;
            font-weight: 500;
            color: $--color-text-primary;
            line-height: 50px;
        }
    }
}

.project,
.calendar,
.timeline,
.discovery {
    box-shadow: 0 1px 2px 0 rgba(161, 171, 181, 0.48),
        0 2px 4px 0 rgba(213, 222, 231, 0.64) !important;
    border: 0 none !important;
}
.project {
    .el-card__header {
        padding: 18px 20px;
    }
    .el-card__body {
        padding: 0;
        position: relative;
    }
    .project-list {
        box-sizing: border-box;
        .project-item {
            float: left;
            width: 33.33%;
            padding: 15px;
            border-bottom: 1px solid $--border-color-lighter;
            border-right: 1px solid $--border-color-lighter;
            box-sizing: border-box;
            transition: $--all-transition;

            &:nth-child(3n + 0) {
                border-right: 0 none;
            }

            &:hover {
                z-index: 1;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
            }

            > h3 {
                vertical-align: top;
                line-height: 24px;
                height: 26px;
                i {
                    font-size: 24px;
                }
                img {
                    display: inline-block;
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                }
                a {
                    display: inline-block;
                    color: $--color-text-primary;
                    font-weight: bold;
                    font-size: 16px;
                    vertical-align: top;
                    margin-left: 15px;
                    &:hover,
                    &:focus {
                        color: $--link-color;
                    }
                }
            }
            > p {
                height: 100px;
                line-height: 22px;
                font-size: 14px;
                color: rgba(0, 0, 0, 0.45);
                padding: 5px 0;
            }

            > div {
                line-height: 32px;
                font-size: 12px;
                a {
                    color: $--color-text-secondary;
                    &:hover,
                    &:focus {
                        color: $--link-color;
                    }
                }
                span {
                    float: right;
                    color: rgba(0, 0, 0, 0.25);
                }
            }
        }
    }
}
.discovery {
    margin-top: 25px;
    .discovery-list {
        display: block;
        position: relative;
        margin: 0;
        padding: 0;
        list-style: none;

        li {
            display: block;
            position: relative;
            padding: 10px 0 10px 40px;
            border-bottom: 1px solid $--border-color-base;

            img {
                display: inline-block;
                position: absolute;
                left: 0;
                top: 15px;
                width: 32px;
                height: 32px;
                border-radius: 50%;
            }
            div {
                padding: 5px 0;
            }
            span {
                color: $--color-text-secondary;
                font-size: 12px;
            }
        }
    }
}
.calendar {
    .el-calendar__body {
        padding: 12px 20px 15px;
    }
    .el-calendar-table {
        .el-calendar-day {
            padding: 13px 0;
            height: auto;
            text-align: center;
        }
    }
}
.timeline {
    margin-top: 25px;

    .el-card {
        border-radius: 0;

        h4 {
            font-weight: normal;
            padding: 0 0 20px 0;
        }
        p {
            font-size: 12px;
            color: $--color-text-secondary;
        }
    }
}
</style>
